/** Marketing services rows for the pricing page comparison table */
export const pricingMarketingServices = [
  {
    name: "Email campaigns",
    tasks: [
      "Audience segmentation & database preparation",
      "Email template design & content creation",
      "Campaign setup & automation workflows",
      "A/B testing & performance optimization",
      "Analytics tracking & detailed reporting",
      "Deliverability monitoring & list hygiene",
    ],
    deliverables: [
      "- 25-40% increase in email open rates",
      "- 15-30% higher click-through rates",
      "- 3-5x more sales from email sequences",
      "- Automated lead nurturing system",
      "- Ready-to-use email templates",
      "- Monthly revenue reports with ROI tracking",
    ],
    price: "Marketing Plan / Negotiated",
  },
  {
    name: "SMS Campaigns",
    tasks: [
      "Audience segmentation & phone list preparation",
      "SMS copywriting & compliance review (STOP link, opt-out)",
      "Sender label / number setup & campaign configuration",
      "A/B testing & send-time optimization",
      "Delivery tracking & detailed reporting",
      "List hygiene & opt-out management",
    ],
    deliverables: [
      "- 95%+ delivery rate on opted-in lists",
      "- 20-35% higher response rates vs email for time-sensitive offers",
      "- 2-4x faster conversions on flash sales & reminders",
      "- Automated SMS sequences (welcome, cart, re-engagement)",
      "- Ready-to-use message templates with compliance built in",
      "- Monthly reports with credits used, delivery & ROI tracking",
    ],
    price: "Marketing Plan / Negotiated",
  },
];
